import { createShell } from '../../shell/createShell';
import { route as extrasCheckoutPage } from './pages/Checkout/checkout';
import { route as extrasAddPaymentMethodPage } from './pages/Prime/addPaymentMethod';
import { route as extrasAddPaymentMethodConfirmationPage } from './pages/Prime/addPaymentMethodConfirmation';
import { route as extrasPayByLinkMembershipValidationPage } from './pages/Prime/paybylinkMembershipValidator';
import { route as extrasPayByLinkContentValidationPage } from './pages/Prime/paybylinkContentValidator';
import { ExtrasFunnel } from '.';
const routes = [extrasCheckoutPage, extrasAddPaymentMethodPage, extrasAddPaymentMethodConfirmationPage, extrasPayByLinkMembershipValidationPage, extrasPayByLinkContentValidationPage];
export const extrasPostbookingShell = createShell(ExtrasFunnel, {
  options: {
    routes,
    namespace: 'extras_postbooking_shell'
  }
});